/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Vertical_Padding_LabelInputs */



/**
* | output |
* | --- |
* | "Vertical Padding (%)" |
*
* @param {Video_Export_Vertical_Padding_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_vertical_padding_label = /** @type {((inputs?: Video_Export_Vertical_Padding_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Vertical_Padding_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Marge verticale (%)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vertikale Polsterung (%)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riempimento verticale (%)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вертикальный отступ (%)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Relleno vertical (%)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("垂直衬垫（%）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("垂直パディング（％）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऊर्ध्वाधर पैडिंग (%)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Preenchimento vertical (%)")
	return /** @type {LocalizedString} */ ("Vertical Padding (%)")
});